import styled from "styled-components";
import { getColor, getSize } from "~/spocketUI/helpers/style";
import { UIProps } from "~/spocketUI/types/style";

interface IPlansGrid extends UIProps {
  isAnnual: boolean;
}

// display: flex;
// gap: ${getSize(2.9)};
// flex-wrap: wrap;
// justify-content: center;
// margin-top: ${getSize(2.6)};

export const PlansGrid = styled.div<IPlansGrid>`
  display: flex;
  flex-wrap: wrap;
  gap: ${getSize(1)};
  margin: ${getSize(3.5)} auto ${getSize(2)} auto;
  justify-content: center;
  align-items: center;
`;

export const ToggleContentText = styled.p`
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  line-height: 19.84px;
  color: ${getColor("textDisabled")};

  &.selected {
    font-weight: 500;
    color: ${getColor("text")};
  }
`;

export const BlurBackground = styled.div`
  &.blur {
    filter: blur(1.5rem);
  }
`;

export const PromotionText = styled.div`
  position: relative;
  background-color: ${getColor("greenSecondary")};
  color: ${getColor("green")};
  margin: 0;
  padding: 2px;
  padding: 2px ${getSize(1)};
  border-radius: ${getSize(3)};
  font-size: 12px;
  font-weight: 500;
  line-height: 18.31px;
`;

export const MonthsOffImgContainer = styled.div`
  position: absolute;
  top: -10px;
  left: -20px;

  @media (max-width: 403px) {
    display: none;
  }
`;
